/*! grapesjs-style-filter - 0.1.3 */
!function (e, t) {
  'object' == typeof exports && 'object' == typeof module ? module.exports = t() : 'function' == typeof define && define.amd ? define([], t) : 'object' == typeof exports ? exports["grapesjs-style-filter"] = t() : e["grapesjs-style-filter"] = t();
}(window, function () {
  return function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: 'Module'
      }), Object.defineProperty(e, '__esModule', {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && 'object' == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, 'default', {
        enumerable: !0,
        value: e
      }), 2 & t && 'string' != typeof e) for (var o in e) r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, 'a', t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 1);
  }([function (e, t) {
    e.exports = function (e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0),
      o = r.n(n);
    function u(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? u(Object(r), !0).forEach(function (t) {
          o()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    t.default = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = i({}, {
          inputFilterType: {},
          inputFilterStrength: {},
          filterStrengthChange: function filterStrengthChange(e) {
            return e;
          }
        }, {}, t),
        n = r.filterStrengthChange,
        o = e.StyleManager,
        u = o.getType('stack'),
        a = u.model,
        l = i({
          property: 'filter_type',
          name: 'Type',
          type: 'select',
          defaults: 'sepia',
          full: 1,
          list: [{
            value: 'blur'
          }, {
            value: 'brightness'
          }, {
            value: 'contrast'
          }, {
            value: 'grayscale'
          }, {
            value: 'hue-rotate'
          }, {
            value: 'invert'
          }, {
            value: 'opacity'
          }, {
            value: 'saturate'
          }, {
            value: 'sepia'
          }]
        }, r.inputFilterType),
        p = i({
          property: 'filter_strength',
          type: 'slider',
          name: 'Strength',
          functionName: 'blur',
          units: ['px'],
          defaults: 100,
          step: 1,
          max: 100,
          min: 0
        }, r.inputFilterStrength);
      o.addType('filter', {
        model: a.extend({
          defaults: function defaults() {
            return i({}, a.prototype.defaults, {
              layerSeparator: ' ',
              properties: [l, n(p)]
            });
          },
          init: function init() {
            this.handleTypeChange = this.handleTypeChange.bind(this), this.listenTo(this.getLayers(), 'add', this.onNewLayerAdd);
          },
          onNewLayerAdd: function onNewLayerAdd(e) {
            var t = e.getPropertyAt(0);
            e.listenTo(t, 'change:value', this.handleTypeChange);
          },
          getLayersFromTarget: function getLayersFromTarget(e) {
            var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              o = r.resultValue,
              u = [],
              a = o || e.getStyle()[this.get('property')];
            return a && a.split(' ').forEach(function (e) {
              var r = t.parseValue(e, {
                  complete: 1,
                  numeric: 1
                }),
                o = r.value,
                a = r.unit,
                c = r.functionName;
              u.push({
                properties: [i({}, l, {
                  value: c
                }), i({}, n(p), {}, t.getStrengthPropsByType(c), {
                  value: o,
                  unit: a
                })]
              });
            }), u;
          },
          handleTypeChange: function handleTypeChange(e, t) {
            var r = this.getStrengthPropsByType(t);
            e.collection.at(1).set(r);
          },
          getStrengthPropsByType: function getStrengthPropsByType(e) {
            var t = '%',
              r = ['%'],
              o = 100;
            switch (e) {
              case 'blur':
                t = 'px', r = ['px'];
                break;
              case 'hue-rotate':
                t = 'deg', r = ['deg'], o = 360;
            }
            return n({
              functionName: e,
              unit: t,
              units: r,
              max: o
            });
          },
          getFullValue: function getFullValue() {
            return this.getLayers().map(function (e) {
              return e.getPropertyAt(1);
            }).map(function (e) {
              return e ? e.getFullValue() : '';
            }).join(' ');
          }
        }),
        view: u.view
      });
    };
  }]);
});